import { InteractionTypes, } from '@/components/oto/customerview/types/customerActivity';
import i18n from '@/i18n';
export const INTERACTION_UI_MAPPING = {
    purchaseOff: {
        icon: 'ShoppingOff',
        title: i18n.global.t('base-management.customer-activity.table-labels.purchase-off'),
    },
    purchaseOn: {
        icon: 'ShoppingOn',
        title: i18n.global.t('base-management.customer-activity.table-labels.purchase-on'),
    },
    contact: {
        icon: 'Contact',
        title: i18n.global.t('base-management.customer-activity.table-labels.contact'),
    },
    reschedule: {
        icon: 'Calendar',
        title: i18n.global.t('base-management.customer-activity.table-labels.reschedule'),
    },
};
export function useCustomerActivity() {
    const isPurchase = (type) => {
        return type === InteractionTypes.PURCHASE_OFF || type === InteractionTypes.PURCHASE_ON;
    };
    const getInteractionIcon = (type) => {
        return INTERACTION_UI_MAPPING[type]?.icon || INTERACTION_UI_MAPPING.contact.icon;
    };
    const getInteractionTitle = (row) => {
        return INTERACTION_UI_MAPPING[row.type]?.title || INTERACTION_UI_MAPPING.contact.title;
    };
    const formatProductsInfo = (order) => {
        return `${order.products} ${i18n.global.tc('base-management.customer-activity.product', order.products)}: R$${order.value.toFixed(2)}`;
    };
    const getStoreInfo = (row) => {
        if (isPurchase(row.type)) {
            return row.order.storeName;
        }
        if (row.type === InteractionTypes.RESCHEDULE) {
            return row.suggestion.storeName;
        }
        return row.storeName;
    };
    const getSellerInfo = (row) => {
        if (isPurchase(row.type)) {
            return row.order.sellerName;
        }
        if (row.type === InteractionTypes.RESCHEDULE) {
            return row.suggestion.seller.name;
        }
        return row.sellerName;
    };
    return {
        isPurchase,
        getStoreInfo,
        getSellerInfo,
        getInteractionIcon,
        formatProductsInfo,
        getInteractionTitle,
    };
}
